/**
 * Route for `impression-tracking`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ImpressionTrackingPage } from "../features/impression-tracking/ImpressionTrackingPage";

export const impressionTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/impression-tracking",
	component: ImpressionTrackingPage,
});

export default impressionTrackingRoute;
